import { toast } from 'react-toastify';
import { DownloadReportsModel, EmployeeNodeModel } from '../../../models';
import { getEmployeesIds } from '../../../utils';
import SelectDate from './select-date/SelectDateProps';
import SelectEmployeesDates from './select-employees-dates/SelectEmployeesDates';
import SelectGroupsAreas from './select-groups-areas/SelectGroupsAreas';
import SelectWorkshiftType from './select-workshift-type/SelectWorkshiftType';
import { useContext } from 'react';
import { AppContext } from '../../context';

interface ReportsModalsWrapperProps {
    isOpenFilterUnattendanceInterruptionsReportModal: boolean;
    isOpenFilterWorkingSchedulingsRepotModal: boolean;
    isOpenFilterInterruptionsRepotModal: boolean;
    isOpenFilterDailyAssistance: boolean;
    isOpenFilterLunchTimeControl: boolean;
    setIsOpenFilterUnattendanceInterruptionsReportModal: (newState: boolean) => void;
    setIsOpenFilterWorkingSchedulingsRepotModal: (newState: boolean) => void;
    setIsOpenFilterInterruptionsRepotModal: (newState: boolean) => void;
    setIsOpenFilterDailyAssistance: (newState: boolean) => void;
    setIsOpenFilterLunchTimeControl: (newState: boolean) => void;

    startDateScheduling: string;
    endDateScheduling: string;
    selectedEmployees: EmployeeNodeModel[];
}

export const ReportsModalsWrapper = ({
    isOpenFilterUnattendanceInterruptionsReportModal,
    isOpenFilterWorkingSchedulingsRepotModal,
    isOpenFilterInterruptionsRepotModal,
    isOpenFilterDailyAssistance,
    isOpenFilterLunchTimeControl,
    setIsOpenFilterDailyAssistance,
    setIsOpenFilterInterruptionsRepotModal,
    setIsOpenFilterLunchTimeControl,
    setIsOpenFilterUnattendanceInterruptionsReportModal,
    setIsOpenFilterWorkingSchedulingsRepotModal,
    endDateScheduling,
    selectedEmployees,
    startDateScheduling,
}: ReportsModalsWrapperProps) => {
    const { langResources, downloadReport } = useContext(AppContext);

    /**
     * Descargamos reporte de faltas e interrupciones filtrando por turno o trae todos sin elegir turno
     * @param parameter number | null
     */
    const handlerSaveReportUnattendanceAndInterruptions = (
        parameter: number | null
    ) => {
        let body: DownloadReportsModel = {
            startDate: '',
            endDate: '',
            employeeIds: [],
        };

        if (parameter === -1) {
            body = {
                startDate: startDateScheduling,
                endDate: endDateScheduling,
                employeeIds: getEmployeesIds(selectedEmployees),
            };
        } else {
            body = {
                startDate: startDateScheduling,
                endDate: endDateScheduling,
                employeeIds: getEmployeesIds(selectedEmployees),
                workshiftId: parameter,
            };
        }

        if (
            body.startDate !== '' &&
            body.endDate !== '' &&
            body.employeeIds &&
            body.employeeIds.length > 0
        ) {
            downloadReport(
                body,
                undefined,
                undefined,
                undefined,
                langResources['reports.message.alert'],
                langResources['unattendance.interruptions.report.filename'],
                '/jerusalem/api/v2.0.0/reports/unattendance-and-interruptions'
            );
        } else {
            toast.error(langResources['reports.message.alert'], {
                isLoading: false,
                autoClose: 5000,
                position: toast.POSITION.BOTTOM_RIGHT,
                closeOnClick: true,
                closeButton: true,
            });
        }
    };

    /**
     * Descargamos el reporte detalles de interrupcion
     * @param employeeSelected number[]
     * @param initDate string
     * @param lastDate string
     */
    const handlerSaveReportInterruptionDetails = (
        employeeSelected: number[],
        initDate: string,
        lastDate: string
    ) => {
        let body: DownloadReportsModel = {
            startDate: initDate + 'T' + '01:00',
            endDate: lastDate + 'T' + '01:00',
            employeeIds: employeeSelected,
        };

        if (
            body.startDate !== '' &&
            body.endDate !== '' &&
            body.employeeIds &&
            body.employeeIds.length > 0
        ) {
            downloadReport(
                body,
                undefined,
                undefined,
                undefined,
                langResources['reports.message.alert'],
                langResources['interruption.details.report.filename'],
                '/jerusalem/api/v2.0.0/reports/employees-interruptions'
            );
            setIsOpenFilterInterruptionsRepotModal(false);
        } else {
            toast.error(langResources['reports.message.alert'], {
                isLoading: false,
                autoClose: 5000,
                position: toast.POSITION.BOTTOM_RIGHT,
                closeOnClick: true,
                closeButton: true,
            });
        }
    };

    /**
     * Descargamos el reporte de programación de turnos lo podemos filtrar por el turno escogido o todos si no escogemos turno
     * @param parameter number | undefined | null
     */
    const handlerSaveReportWorkshiftScheduling = (
        parameter: number | undefined | null
    ) => {
        let body: DownloadReportsModel = {
            startDate: '',
            endDate: '',
            employeeIds: [],
        };

        if (parameter === -1) {
            body = {
                startDate: startDateScheduling,
                endDate: endDateScheduling,
                employeeIds: getEmployeesIds(selectedEmployees),
            };
        } else {
            body = {
                startDate: startDateScheduling,
                endDate: endDateScheduling,
                employeeIds: getEmployeesIds(selectedEmployees),
                workshiftId: parameter,
            };
        }

        if (
            body.startDate !== '' &&
            body.endDate !== '' &&
            body.employeeIds &&
            body.employeeIds.length > 0
        ) {
            downloadReport(
                body,
                undefined,
                undefined,
                undefined,
                langResources['reports.message.alert'],
                langResources['workshift.scheduling.report.filename'],
                '/jerusalem/api/v2.0.0/reports/workshift-schedulings-list-by-workshift'
            );
        } else {
            toast.error(langResources['reports.message.alert'], {
                isLoading: false,
                autoClose: 5000,
                position: toast.POSITION.BOTTOM_RIGHT,
                closeOnClick: true,
                closeButton: true,
            });
        }
    };

    /**
     * Descarga el reporte de tiempo de almuerzo
     * @param areaID number[]
     * @param groupID number[]
     */
    const handlerSaveReportLunchTimeControl = (
        areaID: number[],
        groupID: number[]
    ) => {
        let body: DownloadReportsModel = {
            startDate: startDateScheduling,
            endDate: endDateScheduling,
            employeeIds: getEmployeesIds(selectedEmployees),
        };

        if (
            body.startDate !== '' &&
            body.endDate !== '' &&
            body.employeeIds &&
            body.employeeIds.length > 0
        ) {
            downloadReport(
                body,
                undefined,
                undefined,
                undefined,
                langResources['reports.message.alert'],
                langResources['control.lunch.time.report.filename'],
                '/jerusalem/api/v2.0.0/reports/control-lunch-times-list'
            );
        } else {
            toast.error(langResources['reports.message.alert'], {
                isLoading: false,
                autoClose: 5000,
                position: toast.POSITION.BOTTOM_RIGHT,
                closeOnClick: true,
                closeButton: true,
            });
        }
    };

    /**
     * Descarga el reporte de asistencia diaria
     * @param date string
     */
    const handlerSaveReportDailyAssistance = (date: string) => {
        let body: DownloadReportsModel = {
            startDate: date,
            employeeIds: getEmployeesIds(selectedEmployees),
        };

        if (
            body.startDate !== '' &&
            body.employeeIds &&
            body.employeeIds.length > 0
        ) {
            downloadReport(
                body,
                undefined,
                undefined,
                undefined,
                langResources['reports.message.alert'],
                langResources['daily.attendance.report.filename'],
                '/jerusalem/api/v2.0.0/reports/daily-attendance-list'
            );
        } else {
            toast.error(langResources['reports.message.alert'], {
                isLoading: false,
                autoClose: 5000,
                position: toast.POSITION.BOTTOM_RIGHT,
                closeOnClick: true,
                closeButton: true,
            });
        }
    };

    return (
        <>
            {/* ---- Modales relacionados a los reportes cada uno depende del tipo de filtrado que tenga que realizar*/}
            {isOpenFilterUnattendanceInterruptionsReportModal && (
                <SelectWorkshiftType
                    isOpenModal={isOpenFilterUnattendanceInterruptionsReportModal}
                    modalTitle={
                        langResources[
                            'unattendance.interruptions.filter.modal.report.title'
                        ]
                    }
                    onSubmit={handlerSaveReportUnattendanceAndInterruptions}
                    onClose={() => {
                        setIsOpenFilterUnattendanceInterruptionsReportModal(false);
                    }}
                    showControls={true}
                />
            )}

            {isOpenFilterWorkingSchedulingsRepotModal && (
                <SelectWorkshiftType
                    isOpenModal={isOpenFilterWorkingSchedulingsRepotModal}
                    modalTitle={
                        langResources[
                            'workshift.scheduling.filter.modal.report.title'
                        ]
                    }
                    onSubmit={handlerSaveReportWorkshiftScheduling}
                    onClose={() => {
                        setIsOpenFilterWorkingSchedulingsRepotModal(false);
                    }}
                    showControls={true}
                />
            )}

            {isOpenFilterInterruptionsRepotModal && (
                <SelectEmployeesDates
                    selectedEmplooyes={selectedEmployees}
                    isOpenModal={isOpenFilterInterruptionsRepotModal}
                    modalTitle={
                        langResources[
                            'interruption.details.filter.modal.report.title'
                        ]
                    }
                    onSubmit={handlerSaveReportInterruptionDetails}
                    onClose={() => {
                        setIsOpenFilterInterruptionsRepotModal(false);
                    }}
                    showControls={true}
                />
            )}

            {isOpenFilterDailyAssistance && (
                <SelectDate
                    isOpenModal={isOpenFilterDailyAssistance}
                    onClose={() => setIsOpenFilterDailyAssistance(false)}
                    onSubmit={handlerSaveReportDailyAssistance}
                />
            )}

            {isOpenFilterLunchTimeControl && (
                <SelectGroupsAreas
                    isOpenModal={isOpenFilterLunchTimeControl}
                    onSubmit={handlerSaveReportLunchTimeControl}
                    onClose={() => {
                        setIsOpenFilterLunchTimeControl(false);
                    }}
                />
            )}
        </>
    );
};
